module.exports = __webpack_public_path__ + "img/background_11.3b04ae56.jpg";